import {
  HOME_FETCH_END,
  HOME_FETCH_MORE_END,
  HOME_SHOW_POP_UP,
  HOME_CLOSE_POP_UP,
  HOME_IS_NEED_WINDOW,
} from '../constants';

export default function runtime(state = {
  fixedEntries: [],
  head: [],
  layout: ['talk'],
  talk: { card: [], recommend: [] },
  inited: false,
  pop: false,
  needWindow: false,
  protocolUrl: '',
}, action) {
  switch (action.type) {
    case HOME_FETCH_END:
      return {
        ...state,
        ...action.data,
        inited: true,
      }
    case HOME_FETCH_MORE_END:
      return {
        ...state,
        tagRecommends: state.tagRecommends.slice(4),
        tagRecommendCourses: state.tagRecommendCourses.concat(action.data.tagRecommendCourses),
      }
    case HOME_SHOW_POP_UP:
      return {
        ...state,
        pop: true,
      }
    case HOME_CLOSE_POP_UP:
      return {
        ...state,
        pop: false,
      }
    case HOME_IS_NEED_WINDOW:
      return {
        ...state,
        ...action.data,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/home.js